<div class="banner-container" id="cookie_banner" [ngClass]="affixClass()" *ngIf="showBanner">
    <p id="pBannerText">{{bannerText}}
        <span id="spanCookieText" class="help-text" (click)="openBottomSheet(privacyPolicyLink,privacyPolicyData.privacyNoticeDescription)">
            {{learnMoreText}}
        </span>
    </p>
    <lib-icon-button id="iconCookieClose" [iconName]="'close'" (clicked)="closeBanner()"></lib-icon-button>
</div>
